import { CartAddEvent } from '@theme/events';

/**
 * Circadian Set offer in the cart (snippets/cart-set-offer.liquid).
 * Adds the chosen Daytime variant to the cart, then hands the fresh cart
 * sections to the theme so the drawer and cart page re-render in place.
 * Listeners sit on the element itself because the theme morphs the cart
 * markup on updates, which can swap out the inner form.
 * Without JavaScript the form still posts to /cart/add and lands on the cart.
 */
class BalterraSetOffer extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.onSubmit);
    this.addEventListener('change', this.onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.onSubmit);
    this.removeEventListener('change', this.onChange);
  }

  onChange = (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-set-select]')) return;
    const option = select.selectedOptions[0];
    const image = this.querySelector('.cart-set__image');
    if (!option?.dataset.image || !(image instanceof HTMLImageElement)) return;
    image.removeAttribute('srcset');
    image.src = option.dataset.image;
  };

  onSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-set-form]')) return;
    event.preventDefault();

    const button = form.querySelector('[data-set-button]');
    const error = this.querySelector('[data-set-error]');
    const id = Number(new FormData(form).get('id'));
    if (!id || button?.getAttribute('aria-busy') === 'true') return;

    button?.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    const sectionIds = new Set();
    document.querySelectorAll('cart-items-component').forEach((element) => {
      if (element instanceof HTMLElement && element.dataset.sectionId) sectionIds.add(element.dataset.sectionId);
    });

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id, quantity: 1 }],
          sections: Array.from(sectionIds).join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Add to cart failed');

      const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) =>
        r.json()
      );

      document.dispatchEvent(
        new CartAddEvent(cart, 'balterra-set-offer', {
          source: 'balterra-set-offer',
          itemCount: cart.item_count,
          variantId: String(id),
          sections: data.sections,
        })
      );
    } catch (err) {
      console.error(err);
      if (error) {
        error.textContent = 'That one could not be added just now. Please try another colour or refresh the page.';
        error.hidden = false;
      }
      button?.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('balterra-set-offer')) {
  customElements.define('balterra-set-offer', BalterraSetOffer);
}